export default "__VITE_ASSET__ng9LqD22__"